
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class OilPaintingEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const count = Math.floor(50 * (config.parallaxComplexity || 1.0));
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        const draw = () => {
            for (let i = 0; i < count; i++) {
                const rx = (this.pseudoRandom(i) - 0.5) * width * 2;
                const ry = (this.pseudoRandom(i + 1) - 0.5) * height * 2;
                const w = (50 + this.pseudoRandom(i + 2) * 100) * scale;
                const h = (10 + this.pseudoRandom(i + 3) * 20) * scale;
                
                ctx.save();
                ctx.translate(rx, ry);
                ctx.rotate(this.pseudoRandom(i + 4) * Math.PI);
                ctx.globalAlpha *= 0.3 / (layerIndex + 1);
                
                // Thick brush stroke
                ctx.beginPath();
                ctx.ellipse(0, 0, w, h, 0, 0, Math.PI * 2);
                ctx.fill();
                ctx.restore();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
